import * as React from "react";

const SvgArrowsexpand = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M4.471 8.235V4.471M4.471 4.471h3.764M4.471 4.471l4.705 4.705M19.529 8.235V4.471M19.529 4.471h-3.764M19.529 4.471l-4.705 4.705M4.471 15.765v3.764M4.471 19.529h3.764M4.471 19.529l4.705-4.705M19.529 19.529l-4.705-4.705M19.529 19.529v-3.764M19.529 19.529h-3.764" />
    </g>
  </svg>
);

export default SvgArrowsexpand;
